export default __webpack_public_path__ + "static/margins-after-507c910b39f0d4c724699c360df9dbc1.png";